// Importar acciones
import * as userActions from "../actions/user";
import * as authActions from "../actions/auth";

// Importar dependencias
import AuthServices from "@/services/AuthServices";
import BusinessServices from "@/services/BusinessServices";
import Items from "@/utils/items.js";
import Vue from "vue";

// Declarar estado
const state = {
  profile: null,
  business: null
};

// Declarar getters
const getters = {
  getProfile: state => state.profile,
  getBusiness: state => state.business,
  getMenuItems: state => {
    if (!state.profile) {
      return Items.unauthenticated;
    }

    // Revisar si es restaurante
    const isRestaurant = state.business.sector === "restaurant";

    // Revisar si el usuario es un empleado
    if (state.profile.user_type === "employee") {
      return Items.authenticated.filter(item => {
        const isAllowed =
          state.profile.tabs.includes(item.key) || item.key === "settings";

        if (item.key === "tables") {
          return isRestaurant && isAllowed;
        }

        return isAllowed;
      });
    }

    return Items.authenticated.filter(item => {
      if (item.key === "tables") {
        return isRestaurant;
      }

      return true;
    });
  }
};

// Declarar acciones
const actions = {
  [userActions.USER_PROFILE_REQUEST]: async function({ commit, dispatch }) {
    // Commit del registro
    commit(userActions.PROFILE_REQUEST);

    try {
      // Realizar petición
      const profile = await AuthServices.getProfile();

      // Obtener negocio
      const business = await BusinessServices.getBusiness();

      // Commit de la respuesta exitos
      commit(userActions.BUSINESS_SUCCESS, business);
      commit(userActions.PROFILE_SUCCESS, profile);

      // Obtener primera pestaña
      const { key: firstTab } =
        profile.tabs && profile.tabs?.length > 0
          ? Items.authenticated.find(item => profile.tabs.includes(item.key))
          : { key: "settings" };

      // Commit para actualizar la url de la página de inicio
      if (profile.user_type === "employee") {
        commit(authActions.HOME_ROUTE_UPDATE, firstTab);
      } else {
        commit(authActions.HOME_ROUTE_UPDATE, "dashboard");
      }
    } catch (err) {
      // Revisar si el error es por el token
      const errorStatus = err.response.status;

      // Commit del error
      commit(userActions.PROFILE_ERROR);

      if (errorStatus == 401) {
        // Dispatch para cerrar la sesión
        dispatch(authActions.SIGN_OUT_REQUEST);

        // Regresar un error con otro mensaje
        throw new Error(
          "Expiró el inicio de sesión. Por favor inicia sesión nuevamente"
        );
      } else {
        // Regresar error
        throw new Error(err.response.data.message);
      }
    }
  }
};

const mutations = {
  [userActions.PROFILE_REQUEST]: state => {
    state.status = "loading";
  },
  [userActions.PROFILE_SUCCESS]: (state, profile) => {
    state.status = "success";
    Vue.set(state, "profile", profile);
  },
  [userActions.BUSINESS_SUCCESS]: (state, business) => {
    Vue.set(state, "business", business);
  },
  [userActions.PROFILE_ERROR]: state => {
    state.status = "error";
  },
  [userActions.DELETE_PROFILE]: state => {
    // Remover perfil del estado
    Vue.set(state, "profile", null);
    state.status = "success";
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
